// Module
var code = "<div class=\"form-group form-group-sm\"> <label kform-builder-tooltip=\"{{ tooltipText }}\">{{ label }}</label> <mf order=\"ALL\" ng-model=\"data\" mf-card=\"'0-N'\" placeholder=\"Nodes\"> </mf></div>";
// Exports
export default code;